/*
Pipeline Theme - Custom JS

*/

(function() {

  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Variant:', variant);
    }
  });

  function getUsdTargetInSubunits(usdAmount, cartCurrency) {
    var currency = cartCurrency || (window.theme && window.theme.currencyCode) || 'USD';
    var rate = 1;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      rate = parseFloat(window.Shopify.currency.rate) || 1;
    }
    
    if (currency === 'USD') {
      return usdAmount * 100;
    }

    if (rate !== 1) {
      return Math.round(usdAmount * rate * 100);
    }

    var approxRatesToUsd = {
      'INR': 83.5,
      'EUR': 0.92,
      'GBP': 0.78,
      'CAD': 1.36,
      'AUD': 1.50
    };

    var approxRate = approxRatesToUsd[currency] || 1;
    return Math.round(usdAmount * approxRate * 100);
  }

  function formatMoneyNoDecimals(cents, currencyCode) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : "${{amount}}";
      var formatted = window.Shopify.formatMoney(cents, format);
      return formatted.replace(/\.00$/, '');
    }
    var val = cents / 100;
    var symbol = currencyCode === 'INR' ? 'Rs. ' : '$';
    if (cents % 100 === 0) {
      return symbol + val.toFixed(0);
    } else {
      return symbol + val.toFixed(2);
    }
  }

  function updateCartShippingBar(cart) {
    var shippingBar = document.querySelector('[data-cart-shipping-bar]');
    if (!shippingBar) return;

    var usdTarget = parseFloat(shippingBar.getAttribute('data-target-usd') || '125');
    var cartCurrency = (cart && cart.currency) || (window.theme && window.theme.currencyCode) || 'USD';
    var targetCents = getUsdTargetInSubunits(usdTarget, cartCurrency);
    var cartTotalCents = cart ? cart.total_price : 0;
    var remainingCents = targetCents - cartTotalCents;
    if (remainingCents < 0) remainingCents = 0;

    var percent = (cartTotalCents / targetCents) * 100;
    if (percent > 100) percent = 100;

    var fillEl = shippingBar.querySelector('[data-cart-shipping-fill]');
    if (fillEl) {
      fillEl.style.width = percent + '%';
    }

    var messageEl = shippingBar.querySelector('[data-cart-shipping-message]');
    if (messageEl) {
      if (cartTotalCents >= targetCents) {
        messageEl.textContent = "You've unlocked free shipping!";
      } else {
        var formattedRemaining = formatMoneyNoDecimals(remainingCents, cartCurrency);
        messageEl.textContent = "You're " + formattedRemaining + " away from free shipping";
      }
    }
  }

  document.addEventListener('theme:cart:change', function(event) {
    setTimeout(function() {
      if (typeof GetCurrency === 'function') GetCurrency();
    }, 500);
    
    var cart = event.detail.cart;
    if (cart) {
      updateCartShippingBar(cart);
      if (window.LimeSpot && cart.items) {
        window.LimeSpot.CartItems = cart.items.map(function(item) { return item.product_id; });
      }
      var relatedWrapper = document.querySelector('.section-related-below-images-wrapper');
      var drawerBody = document.querySelector('.drawer__body');
      var cartForm = document.querySelector('[data-cart-form]');
      var cartBottom = document.querySelector('[data-cart-bottom]');
      var cartEmpty = document.querySelector('[data-cart-empty]');

      if (cart.item_count == 0) {
        if (relatedWrapper) relatedWrapper.classList.add('hide');
        if (drawerBody) drawerBody.classList.remove('cart-full');
        if (cartForm) cartForm.classList.add('cart--hidden');
        if (cartBottom) cartBottom.classList.add('cart--hidden');
        if (cartEmpty) cartEmpty.classList.remove('cart--hidden');
      } else {
        if (relatedWrapper) relatedWrapper.classList.remove('hide');
        if (drawerBody) drawerBody.classList.add('cart-full');
        if (cartForm) cartForm.classList.remove('cart--hidden');
        if (cartBottom) cartBottom.classList.remove('cart--hidden');
        if (cartEmpty) cartEmpty.classList.add('cart--hidden');
      }

      if (cart.item_count > 1) {
        var cartItems = document.querySelector('.cart__items');
        if (cartItems) cartItems.classList.add('multiple-cart-items');
      } else {
        var cartItems = document.querySelector('.cart__items');
        if (cartItems) cartItems.classList.remove('multiple-cart-items');
      }
    }
  });

  // Intercept fetch calls to update cart progress bar and open drawer on AJAX cart changes
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function() {
      return originalFetch.apply(this, arguments).then(function(response) {
        if (response && response.url) {
          if (response.url.indexOf('/cart/add') !== -1 && response.ok) {
            setTimeout(function() {
              openCartDrawer();
              window.fetch(window.theme && window.theme.routes ? window.theme.routes.cart + '.js' : '/cart.js')
                .then(function(r) { return r.json(); })
                .then(function(cart) {
                  document.dispatchEvent(new CustomEvent('theme:cart:change', {
                    detail: { cart: cart },
                    bubbles: true
                  }));
                }).catch(function(){});
            }, 50);
          } else if (
            response.url.indexOf('/cart/change') !== -1 ||
            response.url.indexOf('/cart/update') !== -1 ||
            response.url.indexOf('/cart.js') !== -1
          ) {
            response.clone().json().then(function(cartData) {
              if (cartData && typeof cartData.total_price !== 'undefined') {
                updateCartShippingBar(cartData);
              }
            }).catch(function(){});
          }
        }
        return response;
      });
    };
  }

  /* ==========================================================================
     Shipping Protection Toggle & Cart Subtotal Synchronization
     ========================================================================== */
  var PROTECTION_FEE_CENTS = 215;

  function getStoredProtectionState() {
    var stored = localStorage.getItem('shipping_protection_enabled');
    if (stored !== null) {
      return stored === 'true';
    }
    return true; // Default to ON
  }

  function setStoredProtectionState(enabled) {
    localStorage.setItem('shipping_protection_enabled', enabled ? 'true' : 'false');
  }

  function formatPrice(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : "${{amount}}";
      var formatted = window.Shopify.formatMoney(cents, format);
      if (window.theme && window.theme.settings && window.theme.settings.currency_code_enable && window.theme.currencyCode) {
        return formatted + ' ' + window.theme.currencyCode;
      }
      return formatted;
    }
    var val = (cents / 100).toFixed(2);
    var symbol = '$';
    if (window.theme && window.theme.currencyCode === 'INR') symbol = 'Rs. ';
    var result = symbol + val;
    if (window.theme && window.theme.settings && window.theme.settings.currency_code_enable && window.theme.currencyCode) {
      result += ' ' + window.theme.currencyCode;
    }
    return result;
  }

  function syncProtectionUI(isEnabled, baseCartTotalCents) {
    // Sync checkboxes across cart page and cart drawer
    var checkboxes = document.querySelectorAll('[data-shipping-protection-checkbox]');
    checkboxes.forEach(function(cb) {
      if (cb.checked !== isEnabled) {
        cb.checked = isEnabled;
      }
    });

    // Toggle breakdown rows
    var breakdownRows = document.querySelectorAll('[data-shipping-protection-breakdown]');
    breakdownRows.forEach(function(row) {
      if (isEnabled) {
        row.classList.remove('is-hidden');
      } else {
        row.classList.add('is-hidden');
      }
    });

    // Cache latest base total if provided
    if (typeof baseCartTotalCents === 'number') {
      window._latestCartBaseTotalCents = baseCartTotalCents;
    }

    var baseCents = (typeof window._latestCartBaseTotalCents === 'number') ? window._latestCartBaseTotalCents : null;

    // Update all cart final totals (e.g. cart subtotal text & checkout button prices)
    var finalEls = document.querySelectorAll('[data-cart-final]');
    finalEls.forEach(function(el) {
      var currentBase = baseCents;
      if (currentBase === null) {
        var attrBase = el.getAttribute('data-base-total');
        if (attrBase) {
          currentBase = parseInt(attrBase, 10);
        }
      }

      if (currentBase !== null && !isNaN(currentBase)) {
        var displayTotal = isEnabled ? (currentBase + PROTECTION_FEE_CENTS) : currentBase;
        el.innerHTML = formatPrice(displayTotal);
      }
    });
  }

  function updateCartAttributes(isEnabled) {
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root_url)
      ? window.Shopify.routes.root_url
      : '/';
    if (rootUrl.substr(-1) !== '/') rootUrl += '/';
    var updateUrl = rootUrl + 'cart/update.js';

    fetch(updateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Shipping Protection': isEnabled ? 'Yes' : 'No'
        }
      })
    }).catch(function(err) {
      console.warn('Failed to update cart attributes:', err);
    });
  }

  function handleToggleChange(event) {
    var isEnabled = event.target.checked;
    setStoredProtectionState(isEnabled);
    syncProtectionUI(isEnabled);
    updateCartAttributes(isEnabled);
  }

  function initProtectionToggle() {
    var isEnabled = getStoredProtectionState();
    syncProtectionUI(isEnabled);

    document.addEventListener('change', function(e) {
      if (e.target && e.target.matches('[data-shipping-protection-checkbox]')) {
        handleToggleChange(e);
      }
    });

    document.addEventListener('theme:cart:change', function(e) {
      var cart = e.detail && e.detail.cart;
      if (cart && typeof cart.total_price === 'number') {
        window._latestCartBaseTotalCents = cart.total_price;
        var currentState = getStoredProtectionState();
        syncProtectionUI(currentState, cart.total_price);
      }
    });

    if (typeof window._latestCartBaseTotalCents === 'undefined') {
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root_url)
        ? window.Shopify.routes.root_url
        : '/';
      if (rootUrl.substr(-1) !== '/') rootUrl += '/';
      var cartUrl = rootUrl + 'cart.js';

      fetch(cartUrl)
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          if (cart && typeof cart.total_price === 'number') {
            window._latestCartBaseTotalCents = cart.total_price;
            syncProtectionUI(getStoredProtectionState(), cart.total_price);
          }
        })
        .catch(function(){});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProtectionToggle);
  } else {
    initProtectionToggle();
  }

  /* ==========================================================================
     AJAX Load More / Load All for Collection Grid
     ========================================================================== */
  function handleLoadMore(e) {
    var btn = e.target.closest('[data-load-more-btn]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var url = btn.getAttribute('data-href') || btn.getAttribute('href');
    if (!url || btn.getAttribute('data-loading') === 'true') return;

    var mode = btn.getAttribute('data-mode') || 'load_more';
    var isLoadAll = (mode === 'load_all');

    btn.setAttribute('data-loading', 'true');
    var originalText = btn.innerHTML;
    btn.innerHTML = isLoadAll ? 'Loading all products...' : 'Loading...';

    function fetchNextPage(currentUrl) {
      return fetch(currentUrl)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var currentGrid = document.querySelector('.collection__products .js-grid');
          var newGrid = doc.querySelector('.collection__products .js-grid');

          if (currentGrid && newGrid) {
            var newItems = Array.prototype.slice.call(newGrid.children);
            newItems.forEach(function(item) {
              currentGrid.appendChild(item);
            });
          }

          var nextBtn = doc.querySelector('[data-load-more-btn]');
          var nextUrl = nextBtn ? (nextBtn.getAttribute('data-href') || nextBtn.getAttribute('href')) : null;

          if (nextUrl && isLoadAll) {
            return fetchNextPage(nextUrl);
          } else if (nextUrl) {
            btn.setAttribute('data-href', nextUrl);
            btn.setAttribute('href', nextUrl);
            btn.removeAttribute('data-loading');
            btn.innerHTML = originalText;
          } else {
            var container = btn.closest('[data-load-more-container]');
            if (container) container.remove();
          }

          window.dispatchEvent(new Event('resize'));
          document.dispatchEvent(new CustomEvent('theme:resize'));
        });
    }

    fetchNextPage(url).catch(function(err) {
      console.error('Error loading products:', err);
      btn.removeAttribute('data-loading');
      btn.innerHTML = originalText;
    });
  }

  document.addEventListener('click', function(e) {
    if (e.target && e.target.closest('[data-load-more-btn]')) {
      handleLoadMore(e);
    }
  }, true);

  /* ==========================================================================
     Mobile Header Navigation Accordion Toggle
     ========================================================================== */
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-mobile-accordion-toggle]');
    if (!toggle) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var item = toggle.closest('.sliderule__wrapper');
    var panel = item ? item.querySelector('[data-mobile-accordion-panel]') : null;
    var icon = toggle.querySelector('.mobile-accordion__icon');

    if (panel) {
      var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        toggle.setAttribute('aria-expanded', 'false');
        panel.style.display = 'none';
        if (icon) icon.textContent = '+';
      } else {
        toggle.setAttribute('aria-expanded', 'true');
        panel.style.display = 'block';
        if (icon) icon.textContent = '–';
      }
    }
  }, true);

  /* ==========================================================================
     Product Accordion Plus/Minus Icon Synchronization
     ========================================================================== */
  function syncProductAccordions() {
    var accordionBtns = document.querySelectorAll('.product-accordion .accordion__title');
    accordionBtns.forEach(function(btn) {
      var isExpanded = btn.getAttribute('aria-expanded') === 'true';
      var plus = btn.querySelector('.plus-icon');
      var minus = btn.querySelector('.minus-icon');
      if (plus && minus) {
        if (isExpanded) {
          plus.style.setProperty('display', 'none', 'important');
          minus.style.setProperty('display', 'inline-flex', 'important');
        } else {
          plus.style.setProperty('display', 'inline-flex', 'important');
          minus.style.setProperty('display', 'none', 'important');
        }
      }
    });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.product-accordion .accordion__title');
    if (!btn) return;
    setTimeout(syncProductAccordions, 50);
    setTimeout(syncProductAccordions, 300);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncProductAccordions);
  } else {
    syncProductAccordions();
  }

  /* ==========================================================================
     Metafield Color Swatches: Live Product Image Update on Collection Grid
     ========================================================================== */
  function unpackTemplate(wrapper) {
    if (!wrapper) return;
    var tpl = wrapper.querySelector('template');
    if (tpl) {
      if (tpl.content) {
        var clone = tpl.content.cloneNode(true);
        tpl.parentNode.appendChild(clone);
        tpl.remove();
      } else {
        var div = document.createElement('div');
        div.innerHTML = tpl.innerHTML;
        while (div.firstChild) {
          tpl.parentNode.insertBefore(div.firstChild, tpl);
        }
        tpl.remove();
      }
    }
  }

  // Preload image on swatch hover for instant response when clicked
  document.addEventListener('mouseenter', function(e) {
    var swatch = e.target.closest && e.target.closest('[data-metafield-swatch], .color-swatches-metafields a');
    if (!swatch) return;
    var card = swatch.closest('product-grid-item, .product-grid-item, [data-item-id]');
    if (!card) return;

    var imgSrc = swatch.getAttribute('data-image-src') || swatch.getAttribute('data-swatch-image');
    if (imgSrc && !swatch._preloaded) {
      swatch._preloaded = true;
      var preloadImg = new Image();
      preloadImg.src = imgSrc;
      var hoverSrc = swatch.getAttribute('data-hover-image-src');
      if (hoverSrc) {
        var preloadHover = new Image();
        preloadHover.src = hoverSrc;
      }
    }
  }, true);

  // Update card image and link on swatch click
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest && e.target.closest('[data-metafield-swatch], .color-swatches-metafields a');
    if (!swatch) return;

    // Check if swatch is inside a collection / product grid card
    var card = swatch.closest('product-grid-item, .product-grid-item, [data-item-id]');
    if (!card) {
      // Outside collection grid (e.g. on product page) - allow standard product page navigation
      return;
    }

    // Stop link navigation to product page on the collection grid
    e.preventDefault();
    e.stopPropagation();

    var newImgSrc = swatch.getAttribute('data-image-src') || swatch.getAttribute('data-swatch-image');
    var newImgSrcset = swatch.getAttribute('data-image-srcset');
    var newHoverSrc = swatch.getAttribute('data-hover-image-src');
    var newHoverSrcset = swatch.getAttribute('data-hover-image-srcset');

    // 1. Update Primary Product Image
    if (newImgSrc) {
      var primaryWrapper = card.querySelector('[data-grid-image="0"]') || card.querySelector('.product-grid-item__image-wrapper');
      if (primaryWrapper) {
        unpackTemplate(primaryWrapper);

        var primaryImg = primaryWrapper.querySelector('img');
        if (primaryImg) {
          primaryImg.src = newImgSrc;
          if (newImgSrcset) {
            primaryImg.srcset = newImgSrcset;
          }
          primaryImg.removeAttribute('data-srcset');
          primaryImg.removeAttribute('data-src');
        }

        var sources = primaryWrapper.querySelectorAll('source');
        sources.forEach(function(s) {
          s.srcset = newImgSrcset || newImgSrc;
        });

        primaryWrapper.classList.add('is-active');
        primaryWrapper.setAttribute('data-grid-current-image', '');
        primaryWrapper.style.opacity = '1';
        primaryWrapper.style.visibility = 'visible';
      }

      // 2. Update Secondary (Hover) Image if exists
      var hoverWrapper = card.querySelector('[data-grid-image="1"]');
      if (hoverWrapper) {
        unpackTemplate(hoverWrapper);

        var hoverImg = hoverWrapper.querySelector('img');
        if (hoverImg) {
          if (newHoverSrc) {
            hoverImg.src = newHoverSrc;
            if (newHoverSrcset) {
              hoverImg.srcset = newHoverSrcset;
            }
          } else {
            hoverImg.src = newImgSrc;
            if (newImgSrcset) {
              hoverImg.srcset = newImgSrcset;
            }
          }
          hoverImg.removeAttribute('data-srcset');
          hoverImg.removeAttribute('data-src');
        }

        var hSources = hoverWrapper.querySelectorAll('source');
        hSources.forEach(function(s) {
          s.srcset = newHoverSrcset || newHoverSrc || newImgSrcset || newImgSrc;
        });
      }

      // Deactivate any other slide images (e.g. index 2, 3...)
      card.querySelectorAll('[data-grid-image]').forEach(function(wrap) {
        if (wrap.getAttribute('data-grid-image') !== '0') {
          wrap.classList.remove('is-active');
          wrap.removeAttribute('data-grid-current-image');
        }
      });
    }

    // 3. Update Product Links on the Card
    var newUrl = swatch.getAttribute('data-product-url') || swatch.getAttribute('href');
    if (newUrl) {
      var cardLinks = card.querySelectorAll('a[data-grid-link], .product-grid-item__link, .product__grid__title__wrapper a, a[data-product-title-link]');
      cardLinks.forEach(function(link) {
        link.setAttribute('href', newUrl);
      });
      var imageLink = card.querySelector('.product-grid-item__container a[href]');
      if (imageLink) {
        imageLink.setAttribute('href', newUrl);
      }
      var infoLink = card.querySelector('.product__grid__info > a[href]');
      if (infoLink) {
        infoLink.setAttribute('href', newUrl);
      }
    }

    // 4. Update Product Title, Price and Status
    var newTitle = swatch.getAttribute('data-product-title');
    if (newTitle) {
      var titleEl = card.querySelector('.product__grid__title');
      if (titleEl) {
        titleEl.textContent = newTitle;
      }
    }

    var newPrice = swatch.getAttribute('data-product-price');
    if (newPrice) {
      var priceEl = card.querySelector('.product__grid__price .price');
      if (priceEl) {
        priceEl.innerHTML = newPrice;
      }
    }

    var comparePrice = swatch.getAttribute('data-product-compare-price');
    var comparePriceEl = card.querySelector('.product__grid__price .compare-at');
    if (comparePriceEl) {
      if (comparePrice) {
        comparePriceEl.innerHTML = comparePrice;
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    // 5. Update Swatch Visual Active State
    var allSwatchesInCard = card.querySelectorAll('[data-metafield-swatch], .swatch__label, .color-swatches-metafields a');
    allSwatchesInCard.forEach(function(s) {
      s.removeAttribute('aria-current');
      s.removeAttribute('aria-selected');
      s.classList.remove('is-active');
      var parentBtn = s.closest('radio-swatch, .swatch__button');
      if (parentBtn) parentBtn.classList.remove('is-active');
      var lbl = s.querySelector('label') || (s.tagName === 'LABEL' ? s : null);
      if (lbl) lbl.classList.remove('is-active');
    });

    swatch.setAttribute('aria-current', 'true');
    swatch.setAttribute('aria-selected', 'true');
    swatch.classList.add('is-active');
    var clickedParent = swatch.closest('radio-swatch, .swatch__button');
    if (clickedParent) clickedParent.classList.add('is-active');
    var clickedLabel = swatch.querySelector('label') || (swatch.tagName === 'LABEL' ? swatch : null);
    if (clickedLabel) clickedLabel.classList.add('is-active');
  }, true);
})();

/* ==========================================================================
   Variant Selection & Ajax Cart Drawer Controller
   ========================================================================== */
(function() {
  function getSelectedOptions(container) {
    var selected = {};
    var inputs = container.querySelectorAll('input[type="radio"][name^="options["]:checked, select[name^="options["], input[type="hidden"][name^="options["]');
    inputs.forEach(function(input) {
      var match = input.name.match(/options\[(.*?)\]/);
      if (match && match[1]) {
        var optName = match[1].trim();
        if (input.type === 'radio') {
          if (input.checked) selected[optName] = input.value;
        } else {
          selected[optName] = input.value;
        }
      }
    });
    return selected;
  }

  function getProductVariants(container) {
    var jsonEl = container.querySelector('[data-product-variants-json]');
    if (!jsonEl) {
      var section = container.closest('[data-section-type], [data-section-id], .product-page, .product-section') || document;
      jsonEl = section.querySelector('[data-product-variants-json]');
    }
    if (jsonEl && jsonEl.textContent) {
      try {
        return JSON.parse(jsonEl.textContent);
      } catch(e) {
        console.warn('Error parsing variants JSON:', e);
      }
    }
    return null;
  }

  function updateDrawerItemsFromHTML(html) {
    if (!html) return;
    var fresh = document.createElement('div');
    fresh.innerHTML = html;
    var content = fresh.querySelector('[data-api-content]') || fresh.querySelector('.cart__items') || fresh;
    var lineItemsWrap = document.querySelector('[data-line-items]');
    if (content && lineItemsWrap) {
      lineItemsWrap.innerHTML = content.innerHTML || html;
    }

    var hasItems = (fresh.querySelectorAll('[data-cart-item]').length > 0) || (lineItemsWrap && lineItemsWrap.querySelectorAll('[data-cart-item]').length > 0);
    var cartForm = document.querySelector('[data-cart-form]');
    var cartEmpty = document.querySelector('[data-cart-empty]');
    var cartBottom = document.querySelector('[data-cart-bottom]');
    var drawerBody = document.querySelector('.drawer__body');
    var relatedWrapper = document.querySelector('.section-related-below-images-wrapper');

    if (hasItems) {
      if (cartForm) cartForm.classList.remove('cart--hidden');
      if (cartBottom) cartBottom.classList.remove('cart--hidden');
      if (cartEmpty) cartEmpty.classList.add('cart--hidden');
      if (drawerBody) drawerBody.classList.add('cart-full');
      if (relatedWrapper) relatedWrapper.classList.remove('hide');
    } else {
      if (cartForm) cartForm.classList.add('cart--hidden');
      if (cartBottom) cartBottom.classList.add('cart--hidden');
      if (cartEmpty) cartEmpty.classList.remove('cart--hidden');
      if (drawerBody) drawerBody.classList.remove('cart-full');
      if (relatedWrapper) relatedWrapper.classList.add('hide');
    }
  }

  function openCartDrawer() {
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart) ? window.theme.routes.cart : '/cart';
    var cacheBuster = Date.now();

    Promise.all([
      fetch(cartUrl + '?section_id=api-cart-items&_=' + cacheBuster, { cache: 'no-store' }).then(function(r) { return r.text(); }),
      fetch(cartUrl + '?section_id=api-cart-subtotal&_=' + cacheBuster, { cache: 'no-store' }).then(function(r) { return r.text(); }).catch(function(){ return ''; }),
      fetch(cartUrl + '.js?_=' + cacheBuster, { cache: 'no-store' }).then(function(r) { return r.json(); }).catch(function(){ return null; })
    ])
    .then(function(results) {
      var itemsHtml = results[0];
      var subtotalHtml = results[1];
      var cartData = results[2];

      updateDrawerItemsFromHTML(itemsHtml);

      if (subtotalHtml) {
        var subDiv = document.createElement('div');
        subDiv.innerHTML = subtotalHtml;
        var subContent = subDiv.querySelector('[data-api-content]') || subDiv;
        var subEl = document.querySelector('[data-cart-subtotal]');
        if (subEl && subContent) {
          subEl.innerHTML = subContent.innerHTML;
        }
      }

      if (cartData) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cartData },
          bubbles: true
        }));
        updateCartShippingBar(cartData);
      }

      var drawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (drawer) {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: true }));
      }
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    })
    .catch(function(err) {
      console.error('Error updating cart drawer:', err);
      var drawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (drawer) {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: true }));
      }
    });
  }
  window.openCartDrawer = openCartDrawer;

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : "${{amount}}";
      var formatted = window.Shopify.formatMoney(cents, format);
      if (window.theme && window.theme.settings && window.theme.settings.currency_code_enable && window.theme.currencyCode) {
        return formatted + ' ' + window.theme.currencyCode;
      }
      return formatted;
    }
    var val = (cents / 100).toFixed(2);
    var symbol = '$';
    if (window.theme && window.theme.currencyCode === 'INR') symbol = 'Rs. ';
    return symbol + val;
  }

  function updateVariantOnOptionChange(targetInput) {
    var container = targetInput.closest('.product-page, [data-product-form-wrapper], .quickview__form, [data-section-type="product"], .product-section') || targetInput.closest('form') || document;
    var variants = getProductVariants(container);
    if (!variants || !variants.length) return;

    var selectedOptions = getSelectedOptions(container);
    var selectedValues = Object.values(selectedOptions);

    // Find the variant that matches all selected options
    var matchingVariant = variants.find(function(variant) {
      return variant.options.every(function(optVal, idx) {
        var currentSelected = selectedValues[idx];
        return !currentSelected || optVal === currentSelected;
      });
    });

    if (!matchingVariant) {
      matchingVariant = variants.find(function(variant) {
        var allMatch = true;
        Object.keys(selectedOptions).forEach(function(name, idx) {
          if (selectedOptions[name] && variant.options[idx] !== selectedOptions[name]) {
            allMatch = false;
          }
        });
        return allMatch;
      });
    }

    if (!matchingVariant) return;

    // 1. Update Hidden Variant ID inputs
    var idInputs = container.querySelectorAll('input[name="id"]');
    idInputs.forEach(function(inp) {
      if (inp.value != matchingVariant.id) {
        inp.value = matchingVariant.id;
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // 2. Update Alpine state if present
    try {
      if (window.Alpine) {
        var alpineRoot = container.closest('[x-data]') || container.querySelector('[x-data]');
        if (alpineRoot && window.Alpine.$data) {
          var data = window.Alpine.$data(alpineRoot);
          if (data && typeof data.variantId !== 'undefined') {
            data.variantId = matchingVariant.id;
          }
        }
      }
    } catch(e) {}

    // 3. Update Option Label Legend (e.g. "Size: 4")
    var parentSelector = targetInput.closest('[data-split-select-wrapper], [data-swapper-wrapper], fieldset');
    if (parentSelector) {
      var labelTarget = parentSelector.querySelector('[data-swapper-target], [data-option-value]');
      if (labelTarget) {
        labelTarget.textContent = targetInput.value;
      }
    }

    // 4. Update Add To Cart Button State
    // var addToCartBtns = container.querySelectorAll('[data-add-to-cart]');
    // addToCartBtns.forEach(function(btn) {
    //   var textEl = btn.querySelector('[data-add-to-cart-text]');
    //   var priceEl = btn.querySelector('[data-button-price]');

    //   if (matchingVariant.available) {
    //     btn.disabled = false;
    //     btn.removeAttribute('disabled');
    //     if (textEl) {
    //       textEl.textContent = (window.theme && window.theme.strings && window.theme.strings.addToCart) ? window.theme.strings.addToCart : 'Add to Cart';
    //     }
    //   } else {
    //     btn.disabled = true;
    //     btn.setAttribute('disabled', 'disabled');
    //     if (textEl) {
    //       textEl.textContent = (window.theme && window.theme.strings && window.theme.strings.soldOut) ? window.theme.strings.soldOut : 'Sold Out';
    //     }
    //   }

    //   if (priceEl && matchingVariant.price) {
    //     priceEl.textContent = matchingVariant.price_formatted || formatMoney(matchingVariant.price);
    //   }
    // });

    // 5. Update Product Price on page
    var priceContainer = container.querySelector('[data-price-wrapper], .product__price, [data-product-price]');
    if (priceContainer && matchingVariant.price) {
      var currentPriceEl = priceContainer.querySelector('[data-product-price], .product__price--sale, .product__price--regular, .price') || priceContainer;
      if (currentPriceEl) {
        currentPriceEl.innerHTML = matchingVariant.price_formatted || formatMoney(matchingVariant.price);
      }
      var compareEl = container.querySelector('[data-compare-price], .compare-at');
      if (compareEl) {
        if (matchingVariant.compare_at_price > matchingVariant.price) {
          compareEl.innerHTML = matchingVariant.compare_at_price_formatted || formatMoney(matchingVariant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    }

    // 6. Update URL in browser history without page reload
    if (matchingVariant.url && window.history && window.history.replaceState) {
      var newUrl = new URL(matchingVariant.url, window.location.origin);
      window.history.replaceState({ variantId: matchingVariant.id }, '', newUrl.pathname + newUrl.search);
    }

    // 7. Update Media / Image if variant has featured_media
    if (matchingVariant.featured_media_id) {
      var slideshow = container.querySelector('[data-product-slideshow]');
      if (slideshow) {
        slideshow.dispatchEvent(new CustomEvent('theme:image:change', {
          detail: { id: matchingVariant.featured_media_id },
          bubbles: true
        }));
      }
      var verticalImg = container.querySelector('[data-media-id="' + matchingVariant.featured_media_id + '"]');
      if (verticalImg) {
        verticalImg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    // 8. Update sold out states on other options
    updateOptionAvailability(container, variants, selectedOptions);
  }

  function updateOptionAvailability(container, variants, currentSelections) {
    var optionInputs = container.querySelectorAll('input[type="radio"][name^="options["], [data-popout-option]');
    var currentVals = Object.values(currentSelections);

    optionInputs.forEach(function(el) {
      var optVal = el.value || el.getAttribute('data-value');
      var wrapper = el.closest('[data-option-position]');
      if (!wrapper) return;
      var position = parseInt(wrapper.getAttribute('data-option-position'), 10) - 1;

      var hypothetical = currentVals.slice();
      hypothetical[position] = optVal;

      var foundVariant = variants.find(function(v) {
        return hypothetical.every(function(val, idx) {
          return !val || v.options[idx] === val;
        });
      });

      var parentButton = el.closest('.radio__button, .swatch__button, li');
      if (parentButton) {
        parentButton.classList.remove('sold-out', 'unavailable');
      }
      el.classList.remove('sold-out', 'unavailable');

      if (!foundVariant) {
        el.classList.add('unavailable');
        if (parentButton) parentButton.classList.add('unavailable');
      } else if (!foundVariant.available) {
        el.classList.add('sold-out');
        if (parentButton) parentButton.classList.add('sold-out');
      }
    });
  }

  // Global listener for variant option changes
  document.addEventListener('change', function(e) {
    if (e.target && e.target.matches && e.target.matches('input[name^="options["], select[name^="options["]')) {
      updateVariantOnOptionChange(e.target);
    }
  });

  // Global listener for option clicks (e.g. labels, swatches, radio clicks)
  document.addEventListener('click', function(e) {
    var swatchLabel = e.target.closest('[data-swatch-input], label[for], .radio__button label, radio-swatch');
    if (swatchLabel) {
      var forId = swatchLabel.getAttribute('for');
      var radio = forId ? document.getElementById(forId) : swatchLabel.querySelector('input[type="radio"]');
      if (radio && radio.matches && radio.matches('input[name^="options["]')) {
        setTimeout(function() {
          updateVariantOnOptionChange(radio);
        }, 10);
      }
    }
  });

  // Global Form Submit Interceptor to ensure AJAX add-to-cart and drawer opening
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form && form.matches && form.matches('[data-product-form], form[action*="/cart/add"]')) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var btn = form.querySelector('[data-add-to-cart], button[type="submit"][name="add"]');
      if (btn) {
        btn.classList.add('loading');
        btn.setAttribute('disabled', 'disabled');
      }

      var formData = new FormData(form);
      var idInput = form.querySelector('input[name="id"]');
      var variantId = idInput ? idInput.value : formData.get('id');

      if (!variantId) {
        var container = form.closest('.product-page, [data-product-form-wrapper], .product-section') || form;
        var variants = getProductVariants(container);
        if (variants && variants.length) {
          variantId = variants[0].id;
        }
      }

      var qtyInput = form.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : (formData.get('quantity') || 1);
      if (isNaN(qty) || qty < 1) qty = 1;

      var payload = {
        id: parseInt(variantId, 10),
        quantity: qty
      };

      var formElements = form.elements;
      var properties = {};
      for (var i = 0; i < formElements.length; i++) {
        var el = formElements[i];
        if (el.name && el.name.indexOf('properties[') === 0 && el.value) {
          var propName = el.name.replace(/^properties\[/, '').replace(/\]$/, '');
          properties[propName] = el.value;
        }
      }
      if (Object.keys(properties).length > 0) {
        payload.properties = properties;
      }
      var sellingPlan = formData.get('selling_plan');
      if (sellingPlan) {
        payload.selling_plan = sellingPlan;
      }

      var cartBase = (window.theme && window.theme.routes && window.theme.routes.cart) ? window.theme.routes.cart : '/cart';

      fetch(cartBase + '/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
      .then(function(res) {
        if (!res.ok) {
          return res.json().then(function(err) { throw err; });
        }
        return res.json();
      })
      .then(function(item) {
        if (btn) {
          btn.classList.remove('loading');
          btn.classList.add('has-success');
          setTimeout(function() {
            btn.classList.remove('has-success');
            btn.removeAttribute('disabled');
          }, 2000);
        }

        openCartDrawer();
      })
      .catch(function(error) {
        console.error('Add to cart error:', error);
        if (btn) {
          btn.classList.remove('loading');
          btn.removeAttribute('disabled');
        }
        var errorDisplay = form.querySelector('[data-error-display], [data-form-errors], .add-action-errors');
        if (errorDisplay) {
          var msg = (error && (error.description || error.message)) ? (error.description || error.message) : 'Error adding to cart. Please try again.';
          errorDisplay.innerHTML = '<div class="errors">' + msg + '</div>';
          errorDisplay.style.display = 'block';
          setTimeout(function() {
            errorDisplay.style.display = 'none';
          }, 5000);
        }
      });
    }
  }, true);

  // Initialize option availability for current selection on load
  function initProductVariants() {
    var containers = document.querySelectorAll('.product-page, [data-product-form-wrapper], [data-section-type="product"]');
    containers.forEach(function(c) {
      var variants = getProductVariants(c);
      if (variants) {
        var selected = getSelectedOptions(c);
        updateOptionAvailability(c, variants, selected);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductVariants);
  } else {
    initProductVariants();
  }
})();